import { Button, Form, Select, Space } from "antd";
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import SelectDownIcon from "../../../../assets/icons/SelectDownIcon";
import CardTitle from "../../../../components/common/CardTitle";
import CustomCard from "../../../../components/common/CustomCard";
import SuccessModal from "../../../../components/common/SuccessModal";
import {
  useCreateRoleMutation,
  useGetAllProductQuery,
} from "../../../../features/portal/Products/productsApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import SidebarLayout from "../../../../layouts/SidebarLayout";

export default function AddEditNewRoll() {
  const { open, handleOpen, handleClose } = useModal();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const backLink = "/admin/users-roll-access/user-list";
  const { id } = useParams();

  const {
    isError: isAllProductError,
    error: allProductError,
    data: getAllProduct,
  } = useGetAllProductQuery({
    params: {
      limit: 100,
    },
  });
  const [
    createRole,
    {
      isError: isCreateRollError,
      error: createRollError,
      isLoading: isCreateRollLoading,
      isSuccess: isCreateRollSuccess,
    },
  ] = useCreateRoleMutation();

  useError(isAllProductError, allProductError, "Get all product fail");
  useError(isCreateRollError, createRollError, "Role create fail");

  const allProduct = getAllProduct?.data?.data;

  const onFinish = (values: any) => {
    const matchedProduct = allProduct?.find(
      (product: any) => product?.id === values?.projectId
    );

    const capitalizedRoleName =
      values?.roleName?.charAt(0).toUpperCase() +
      values?.roleName?.slice(1).toLowerCase();

    const newData = {
      projectId: values?.projectId,
      roleName: capitalizedRoleName,
      description: matchedProduct?.description,
      keycloakClientId: matchedProduct?.keycloakClientId,
    };

    createRole(newData);
  };

  const handleOkay = () => {
    handleClose();
    navigate(`/admin/users-roll-access/user-list`);
  };

  useEffect(() => {
    if (isCreateRollSuccess) {
      form.setFieldsValue({});
      handleOpen({ type: "ADD" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCreateRollSuccess]);

  return (
    <>
      {open?.type === "ADD" && (
        <SuccessModal
          open={open?.open}
          handleClose={handleClose}
          handleOkay={handleOkay}
          data={open?.data}
          title="Successfully New Role Created"
        />
      )}

      <SidebarLayout
        title={`${id ? "Edit Role" : "Add New Role"}`}
        backLink="/admin/users-roll-access/user-list"
      >
        <Form
          className="custom-form"
          layout="vertical"
          requiredMark="optional"
          size="large"
          onFinish={onFinish}
          form={form}
        >
          <CustomCard className=" p-6 pb-0 rounded-b-none">
            <CardTitle>Role Info</CardTitle>
            <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-x-6 pt-4 mb-6">
              <Form.Item
                label="Role Name"
                name="roleName"
                rules={[{ required: true, message: "Please enter Role name" }]}
              >
                <Select
                  placeholder="Select Role Name"
                  className="w-full"
                  suffixIcon={<SelectDownIcon />}
                  style={{ width: "100%" }}
                  allowClear
                  showSearch
                  optionFilterProp="label"
                  options={[
                    { label: "User", value: "User" },
                    { label: "Maker", value: "Maker" },
                    { label: "Checker", value: "Checker" },
                    { label: "Approver", value: "Approver" },
                    { label: "Admin", value: "Admin" },
                    { label: "Manager", value: "Manager" },
                    { label: "HR", value: "HR" },
                    { label: "Employee", value: "Employee" },
                    // { label: "Region", value: "region" },
                    { label: "Zonal", value: "region" },
                    { label: "Cluster", value: "cluster" },
                    { label: "DirectorOps", value: "directorOps" },
                    { label: "EnergyOps", value: "energyOps" },
                    { label: "GR", value: "gr" },
                    { label: "Finance", value: "finance" },
                    // { label: "Sheba", value: "sheba" },
                    { label: "Vendor", value: "vendor" },
                    // { label: "Tparty", value: "tparty" },
                    { label: "Admin", value: "edatco" },
                    { label: "PG", value: "pg" },
                    { label: "SCM", value: "scm" },
                  ]}
                />
              </Form.Item>

              <Form.Item
                label="Select Project"
                name="projectId"
                rules={[{ required: true, message: "Please select project" }]}
              >
                <Select
                  showSearch
                  placeholder="Select Project"
                  options={
                    allProduct?.map((project: any) => ({
                      label: project?.name,
                      value: project?.id,
                    })) || []
                  }
                  className="w-full"
                  suffixIcon={<SelectDownIcon />}
                  style={{ width: "100%" }}
                  allowClear
                  optionFilterProp="label"
                />
              </Form.Item>
            </div>
          </CustomCard>

          {/* sticky bottom-0 */}
          <div className="p-6 rounded-md rounded-t-none bg-white border border-t-0 border-light">
            <Space className="w-full mt-2" size={12}>
              <Link to={backLink}>
                <Button
                  className="normal-dark-button modal-button"
                  size="middle"
                >
                  Cancel
                </Button>
              </Link>
              <Button
                className="modal-button"
                type="primary"
                htmlType="submit"
                size="middle"
                loading={isCreateRollLoading}
              >
                {id ? "Update" : "Create a Role"}
              </Button>
            </Space>
          </div>
        </Form>
      </SidebarLayout>
    </>
  );
}
